export type Lang = "es" | "en";

const STORAGE_KEY = "tripPlanner.lang";
const DEFAULT_LANG: Lang = "es";

const messages = {
  es: {
    appTitle: "Planificador de Viaje",
    searchPlaceholder: "Busca una ciudad…",
    emptyHint:
      "Aún no hay paradas. Busca una ciudad o haz clic en el mapa para añadir una.",
    noMatches: "Sin resultados.",
    searchFailed: "Error al buscar. Intenta de nuevo.",
    dragToReorder: "Arrastra para reordenar",
    rename: "Renombrar",
    delete: "Eliminar",
    showOnMap: "Mostrar en el mapa",
    lookingUp: "Buscando ubicación…",
    noCityHere: "No se encontró ninguna ciudad en este punto.",
    lookupFailed: "Error de búsqueda. Intenta de nuevo.",
    addCityPrompt: "¿Añadir <strong>{city}</strong> al viaje?",
    addToTrip: "Añadir al viaje",
    cancel: "Cancelar",
    fitToAllStops: "Ajustar a todas las paradas",
    export: "Exportar",
    import: "Importar",
    importReplaceConfirm:
      "¿Reemplazar tu viaje actual ({existing} paradas) con el importado ({incoming} paradas)?",
    importFailed: "Error al importar: {reason}",
    importErrorNotJson: "El archivo no es JSON válido.",
    importErrorNotObject: 'Se esperaba un objeto con un arreglo "stops".',
    importErrorMalformed: "La parada #{n} está mal formada.",
    languageToggle: "Cambiar idioma",
    themeToggle: "Cambiar tema",
    collapseRail: "Plegar el panel",
    expandRail: "Abrir el panel",
    tripNights: "{n} noches",
    tripNightsOne: "1 noche",
    stopExpand: "Mostrar detalle",
    stopCollapse: "Ocultar detalle",
    stopEditAll: "Editar todo",
    stopPlacesChip: "Lugares",
    stopExcursionsChip: "Excursiones",
    stopNoDatesHint: "Añadí fechas y transporte…",
    stopArrivalLabel: "Llegada",
    stopDepartureLabel: "Salida",
    editTitle: "Editar parada",
    editCity: "Ciudad",
    editDateFrom: "Desde",
    editDateTo: "Hasta",
    editArriveBy: "Llego en",
    editDepartBy: "Salgo en",
    editNotes: "Notas",
    editNone: "—",
    editNotesPlaceholder: "Lugares para visitar, recordatorios…",
    save: "Guardar",
    travelPlane: "Avión",
    travelTrain: "Tren",
    travelBus: "Autobús",
    travelCar: "Coche",
    summary: "Resumen",
    summaryTitle: "Resumen del viaje",
    summaryHeading: "Mi viaje",
    summaryStopCount: "{n} paradas",
    summaryStopCountOne: "1 parada",
    summaryTotalKm: "{km} km",
    summaryCopy: "Copiar",
    summaryCopied: "✓ Copiado",
    summaryClose: "Cerrar",
    summaryEmpty: "Aún no hay paradas en tu viaje.",
    drawerOpen: "Abrir paradas",
    drawerClose: "Cerrar paradas",
    tripMenu: "Menú",
    share: "Compartir enlace",
    shareCopied: "✓ Enlace copiado",
    shareFailed: "No se pudo copiar el enlace.",
    unitH: "h",
    unitM: "min",
    mapStyleOsm: "Mapa estándar",
    mapStyleVoyager: "Voyager",
    mapStyleTopo: "Topográfico",
    shortcutsTitle: "Atajos de teclado",
    shortcutsSearch: "Enfocar búsqueda",
    shortcutsFit: "Ajustar mapa a las paradas",
    shortcutsSummary: "Abrir resumen del viaje",
    shortcutsHelp: "Mostrar esta ayuda",
    shortcutsCloseRow: "Cerrar diálogo o panel",
    shortcutsClose: "Cerrar",
    helpMenu: "Ayuda",
    tabGeneral: "General",
    tabHotel: "Hotel",
    tabTravel: "Viaje",
    tabPlaces: "Lugares",
    tabExcursions: "Excursiones",
    editHotelName: "Nombre del hotel",
    editHotelAddress: "Dirección",
    editHotelMaps: "Link de Google Maps",
    editHotelCheckIn: "Check-in",
    editHotelCheckOut: "Check-out",
    editHotelPrice: "Precio",
    editHotelCurrency: "Moneda",
    editCarrierArrive: "Compañía (llegada)",
    editTicketRefArrive: "Ref. billete (llegada)",
    editDepartureTimeArrive: "Hora salida (llegada)",
    editArrivalTimeArrive: "Hora llegada",
    editTravelPriceArrive: "Precio (llegada)",
    editCarrierDepart: "Compañía (salida)",
    editTicketRefDepart: "Ref. billete (salida)",
    editDepartureTimeDepart: "Hora salida",
    editArrivalTimeDepart: "Hora llegada (salida)",
    editTravelPriceDepart: "Precio (salida)",
    editTravelCurrency: "Moneda",
    editPlacesTitle: "Lugares a visitar",
    addPlace: "Añadir",
    removePlace: "Eliminar lugar",
    editPlacesSearchPlaceholder: "Buscar lugar…",
    editPlacesClickHint: "Clic en el mapa",
    editPlacesClickActive: "Haz clic en el mapa…",
    exportPlacesKml: "Exportar KML",
    addExcursion: "Añadir excursión",
    saveExcursion: "Guardar excursión",
    removeExcursion: "Eliminar excursión",
    editExcursion: "Editar excursión",
    excursionName: "Nombre",
    excursionTimeFrom: "Desde",
    excursionTimeTo: "Hasta",
    excursionCoords: "Coordenadas",
    excursionCoordsPlaceholder: "48.8049, 2.1204",
    excursionCoordsInvalid: "Coordenadas inválidas",
    excursionMapsUrl: "Link de Google Maps",
    excursionNotes: "Notas",
    excursionNameRequired: "Poné un nombre",
    excursionsEmpty: "Sin excursiones todavía.",
    tripNamePlaceholder: "Mi viaje",
    placesFilterAll: "Todas las ciudades",
    placesFilterNone: "Ninguna ciudad",
    layerHotels: "Hoteles",
    layerExcursions: "Excursiones",
    dayRoutePlan: "Planificar ruta del día",
    dayRouteTitle: "Ruta del día",
    dayRouteLoading: "Calculando ruta…",
    dayRouteFailed: "No se pudo calcular la ruta. Intenta de nuevo.",
    dayRouteNoPlaces: "Añade al menos 2 lugares con coordenadas para planificar.",
    dayRouteWalk: "A pie",
    dayRouteTransit: "Transporte",
    dayRouteEstimated: "estimado",
    dayRouteTotalTime: "Total: {t}",
    dayRouteRecalculate: "Recalcular",
    dayRouteRoundtrip: "Ida y vuelta desde el hotel",
    dayRouteExportGpx: "Exportar GPX",
    dayRouteBack: "Volver a lugares",
    savedTrips: "Viajes guardados",
    savedTripsTitle: "Viajes guardados",
    savedTripsOpen: "Abrir viaje",
    savedTripsDelete: "Eliminar viaje",
    savedTripsDeleteConfirm: '¿Eliminar por completo el viaje "{name}"? Esta acción no se puede deshacer.',
    savedTripsNew: "Nuevo viaje",
    savedTripsEmpty: "No hay viajes guardados todavía.",
    savedTripsActive: "Activo",
    savedTripsUntitled: "(sin nombre)",
    savedTripsStopCount: "{n} paradas",
    savedTripsStopCountOne: "1 parada",
    savedTripsClose: "Cerrar",
    savedTripsCompare: "Comparar viajes",
  },
  en: {
    appTitle: "Trip Planner",
    searchPlaceholder: "Search a city…",
    emptyHint:
      "No stops yet. Search a city or click anywhere on the map to add one.",
    noMatches: "No matches.",
    searchFailed: "Search failed. Try again.",
    dragToReorder: "Drag to reorder",
    rename: "Rename",
    delete: "Delete",
    showOnMap: "Show on map",
    lookingUp: "Looking up location…",
    noCityHere: "No city found at this point.",
    lookupFailed: "Lookup failed. Try again.",
    addCityPrompt: "Add <strong>{city}</strong> to your trip?",
    addToTrip: "Add to trip",
    cancel: "Cancel",
    fitToAllStops: "Fit map to all stops",
    export: "Export",
    import: "Import",
    importReplaceConfirm:
      "Replace your current trip ({existing} stops) with the imported one ({incoming} stops)?",
    importFailed: "Import failed: {reason}",
    importErrorNotJson: "File is not valid JSON.",
    importErrorNotObject: 'Expected an object with a "stops" array.',
    importErrorMalformed: "Stop #{n} is malformed.",
    languageToggle: "Change language",
    themeToggle: "Toggle theme",
    collapseRail: "Collapse panel",
    expandRail: "Open panel",
    tripNights: "{n} nights",
    tripNightsOne: "1 night",
    stopExpand: "Show detail",
    stopCollapse: "Hide detail",
    stopEditAll: "Edit all",
    stopPlacesChip: "Places",
    stopExcursionsChip: "Day trips",
    stopNoDatesHint: "Add dates and transport…",
    stopArrivalLabel: "Arrival",
    stopDepartureLabel: "Departure",
    editTitle: "Edit stop",
    editCity: "City",
    editDateFrom: "From",
    editDateTo: "To",
    editArriveBy: "Arrive by",
    editDepartBy: "Depart by",
    editNotes: "Notes",
    editNone: "—",
    editNotesPlaceholder: "Places to visit, reminders…",
    save: "Save",
    travelPlane: "Plane",
    travelTrain: "Train",
    travelBus: "Bus",
    travelCar: "Car",
    summary: "Summary",
    summaryTitle: "Trip summary",
    summaryHeading: "My trip",
    summaryStopCount: "{n} stops",
    summaryStopCountOne: "1 stop",
    summaryTotalKm: "{km} km",
    summaryCopy: "Copy",
    summaryCopied: "✓ Copied",
    summaryClose: "Close",
    summaryEmpty: "Your trip has no stops yet.",
    drawerOpen: "Open stops",
    drawerClose: "Close stops",
    tripMenu: "Menu",
    share: "Share link",
    shareCopied: "✓ Link copied",
    shareFailed: "Couldn't copy the link.",
    unitH: "h",
    unitM: "m",
    mapStyleOsm: "Standard",
    mapStyleVoyager: "Voyager",
    mapStyleTopo: "Topographic",
    shortcutsTitle: "Keyboard shortcuts",
    shortcutsSearch: "Focus search",
    shortcutsFit: "Fit map to stops",
    shortcutsSummary: "Open trip summary",
    shortcutsHelp: "Show this help",
    shortcutsCloseRow: "Close dialog or panel",
    shortcutsClose: "Close",
    helpMenu: "Help",
    tabGeneral: "General",
    tabHotel: "Hotel",
    tabTravel: "Travel",
    tabPlaces: "Places",
    // "Day trips", not "Excursions" — matches the copy Ruta already ships in English.
    tabExcursions: "Day trips",
    editHotelName: "Hotel name",
    editHotelAddress: "Address",
    editHotelMaps: "Google Maps link",
    editHotelCheckIn: "Check-in",
    editHotelCheckOut: "Check-out",
    editHotelPrice: "Price",
    editHotelCurrency: "Currency",
    editCarrierArrive: "Carrier (arrival)",
    editTicketRefArrive: "Ticket ref (arrival)",
    editDepartureTimeArrive: "Departure time (arrival)",
    editArrivalTimeArrive: "Arrival time",
    editTravelPriceArrive: "Price (arrival)",
    editCarrierDepart: "Carrier (departure)",
    editTicketRefDepart: "Ticket ref (departure)",
    editDepartureTimeDepart: "Departure time",
    editArrivalTimeDepart: "Arrival time (departure)",
    editTravelPriceDepart: "Price (departure)",
    editTravelCurrency: "Currency",
    editPlacesTitle: "Places to visit",
    addPlace: "Add",
    removePlace: "Remove place",
    editPlacesSearchPlaceholder: "Search place…",
    editPlacesClickHint: "Click on map",
    editPlacesClickActive: "Click on the map…",
    exportPlacesKml: "Export KML",
    addExcursion: "Add day trip",
    saveExcursion: "Save day trip",
    removeExcursion: "Remove day trip",
    editExcursion: "Edit day trip",
    excursionName: "Name",
    excursionTimeFrom: "From",
    excursionTimeTo: "To",
    excursionCoords: "Coordinates",
    excursionCoordsPlaceholder: "48.8049, 2.1204",
    excursionCoordsInvalid: "Invalid coordinates",
    excursionMapsUrl: "Google Maps link",
    excursionNotes: "Notes",
    excursionNameRequired: "Give it a name",
    excursionsEmpty: "No day trips yet.",
    tripNamePlaceholder: "My trip",
    placesFilterAll: "All cities",
    placesFilterNone: "No cities",
    layerHotels: "Hotels",
    layerExcursions: "Day trips",
    dayRoutePlan: "Plan day route",
    dayRouteTitle: "Day Route",
    dayRouteLoading: "Calculating route…",
    dayRouteFailed: "Couldn't calculate route. Try again.",
    dayRouteNoPlaces: "Add at least 2 places with coordinates to plan a route.",
    dayRouteWalk: "Walk",
    dayRouteTransit: "Transit",
    dayRouteEstimated: "estimated",
    dayRouteTotalTime: "Total: {t}",
    dayRouteRecalculate: "Recalculate",
    dayRouteRoundtrip: "Roundtrip from hotel",
    dayRouteExportGpx: "Export GPX",
    dayRouteBack: "Back to places",
    savedTrips: "Saved trips",
    savedTripsTitle: "Saved trips",
    savedTripsOpen: "Open trip",
    savedTripsDelete: "Delete trip",
    savedTripsDeleteConfirm: 'Delete the trip "{name}" completely? This cannot be undone.',
    savedTripsNew: "New trip",
    savedTripsEmpty: "No saved trips yet.",
    savedTripsActive: "Active",
    savedTripsUntitled: "(untitled)",
    savedTripsStopCount: "{n} stops",
    savedTripsStopCountOne: "1 stop",
    savedTripsClose: "Close",
    savedTripsCompare: "Compare trips",
  },
} as const;

export type MessageKey = keyof (typeof messages)["es"];

class I18n extends EventTarget {
  private lang: Lang;

  constructor() {
    super();
    const saved = localStorage.getItem(STORAGE_KEY);
    this.lang = saved === "es" || saved === "en" ? saved : DEFAULT_LANG;
  }

  current(): Lang {
    return this.lang;
  }

  setLang(lang: Lang): void {
    if (lang === this.lang) return;
    this.lang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
    this.dispatchEvent(new Event("change"));
  }

  toggle(): void {
    this.setLang(this.lang === "es" ? "en" : "es");
  }

  t(key: MessageKey, vars?: Record<string, string | number>): string {
    let str: string = messages[this.lang][key] ?? messages.en[key] ?? key;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        str = str.replaceAll(`{${k}}`, String(v));
      }
    }
    return str;
  }
}

export const i18n = new I18n();

export function applyStaticTranslations(root: ParentNode = document): void {
  document.documentElement.lang = i18n.current();
  root.querySelectorAll<HTMLElement>("[data-i18n]").forEach((el) => {
    const key = el.dataset.i18n as MessageKey | undefined;
    if (key) el.textContent = i18n.t(key);
  });
  root
    .querySelectorAll<HTMLElement>("[data-i18n-placeholder]")
    .forEach((el) => {
      const key = el.dataset.i18nPlaceholder as MessageKey | undefined;
      if (key && "placeholder" in el) {
        (el as HTMLInputElement).placeholder = i18n.t(key);
      }
    });
  root.querySelectorAll<HTMLElement>("[data-i18n-title]").forEach((el) => {
    const key = el.dataset.i18nTitle as MessageKey | undefined;
    if (key) {
      el.title = i18n.t(key);
      el.setAttribute("aria-label", i18n.t(key));
    }
  });
}
